import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { authActions } from '../../redux/actions/auth';

class Logout extends Component {
    async componentDidMount() {
        const { removeCurrentUser, history, location } = this.props;

        if (
            typeof location.state !== 'undefined' &&
            typeof location.state.logout !== 'undefined' &&
            location.state.logout === true
        ) {
            removeCurrentUser();
        } else {
            history.push('/');
        }
    }

    render() {
        return <div />;
    }
}

const mapDispatchToProps = dispatch => {
    return {
        removeCurrentUser: history => dispatch(authActions.removeCurrentUser(history)),
    };
};

export default connect(null, mapDispatchToProps)(withRouter(Logout));
